import {formatDate} from '@angular/common';

export const constants = {
  appVersion: "0.1.0",
  buildCode: '20211104', //formatDate(Date.now(),'yyyyMMdd','en-US'),
  isMockEnabled: false,
  USER_KEY: 'authf649fc9a5f55',
  LANGUAGE_KEY: 'language',
  PAGINATION_PREFERENCE: 'pagination',
  DEFAULT_PAGE_SIZE: 20
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
